module.exports = __webpack_public_path__ + "img/git.058f9ca5.svg";